import React from "react";
import styled from "styled-components";
import {isEmpty} from "../helpers/helpers";

function Input({children, className, label, labelPositionLeft, type, name, onChange, value, id, help, placeholder, isInvalid, invalidFeedback, inputClassName, onKeyDown, onClick, autoFocus, autoCompleteOff, readOnly = false}) {

    return (
        <div className={"position-relative form-group " + (className ? className : "")}>
            {!isEmpty(label) ? <label htmlFor={id} dangerouslySetInnerHTML={{__html: label}}/> : ""}
            {!isEmpty(labelPositionLeft) ? <LabelPositionLeft className={(isInvalid ? "is-invalid" : "")} dangerouslySetInnerHTML={{__html: labelPositionLeft}}/> : ""}

            <Field
                type={type}
                name={name}
                value={typeof value !== "undefined" ? value : ""}
                onKeyDown={onKeyDown}
                onChange={onChange}
                onClick={onClick}
                className={"form-control " + (isInvalid ? "is-invalid" : "") + (inputClassName ?? '')}
                id={id}
                placeholder={placeholder ?? ""}
                autoFocus={(!!autoFocus)}
                autoComplete={(autoCompleteOff ? 'off' : '')}
                readOnly={readOnly}
            />

            {help ? <small className="form-text text-muted">{help}</small> : ""}

            {
                (isInvalid) ?
                    <div className="invalid-feedback">{invalidFeedback}</div>
                    : ''
            }

            {children ?? ''}
        </div>
    );
}

export default Input;

// styles

const Field = styled.input`
    &.is-invalid {
        padding-right: 1rem;
        padding-left: calc(1.8em + 1rem);
        background-position: left calc(0.45em + 0.25rem) center;
	}
`;

const LabelPositionLeft = styled.span`
    position: absolute;
    top: 10px;
    left: 16px;
    text-align: left;
    font-size: 12px;
    
    &.is-invalid {
        left: 40px;
    }
`;
